



/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// GETMANAGEMENTDASHBOARDDATA
// GETMANAGEMENTDASHBOARDDATA


const GETMANAGEMENTDASHBOARDDATA= createAsyncThunk(
  "getManagementDashboardData/getManagementDashboardData",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getManagementDashboardDataSlice = createSlice({
  name: "getManagementDashboardDataSlice",
  initialState: {
    getManagementDashboardData: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetManagementDashboardData: (state) => {
        state.getManagementDashboardData.loading = false
        state.getManagementDashboardData.error = false
        state.getManagementDashboardData.data = []
        state.getManagementDashboardData.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETMANAGEMENTDASHBOARDDATA.fulfilled, (state, action) => {
      state.getManagementDashboardData = {
        ...state.getManagementDashboardData,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETMANAGEMENTDASHBOARDDATA.pending, (state, action) => {
      state.getManagementDashboardData = {
        ...state.getManagementDashboardData,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETMANAGEMENTDASHBOARDDATA.rejected, (state, action) => {
      state.getManagementDashboardData = {
        ...state.getManagementDashboardData,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getManagementDashboardDataAction = {
    GETMANAGEMENTDASHBOARDDATA,
};

export { getManagementDashboardDataAction };
export default getManagementDashboardDataSlice.reducer;
export const {setInitialStateOfgetManagementDashboardData} = getManagementDashboardDataSlice.actions
